import { useQuery } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { BI_BASE_URL } from '@app/contstants/endpoints';
import { ManagerHashrateLineResponse } from '../types';
import { QUERY_KEY_MANAGER_PERFORMANCE } from '../query-keys';

type Params = {
  managerId?: number | null;
  dateFrom?: string | null;
  dateTo?: string | null;
};

export const getManagerHashrateLine = async ({
  managerId,
  dateFrom,
  dateTo,
}: Params): Promise<ManagerHashrateLineResponse> => {
  const params: Record<string, string | number> = {};

  if (managerId) params.manager_id = managerId;
  if (dateFrom) params.date_from = dateFrom;
  if (dateTo) params.date_to = dateTo;

  const { data } = await api.get<ManagerHashrateLineResponse>(
    `${BI_BASE_URL}/managers/manager/hashrate/line`,
    { params }
  );

  return data ?? [];
};

export const useGetManagerHashrateLine = (
  managerId: number | null,
  dateFrom?: string | null,
  dateTo?: string | null
) => {
  return useQuery({
    queryKey: [QUERY_KEY_MANAGER_PERFORMANCE.MANAGER_HASHRATE_LINE, managerId, dateFrom, dateTo],
    queryFn: () => getManagerHashrateLine({ managerId, dateFrom, dateTo }),
    enabled: !!managerId || (!!dateFrom && !!dateTo),
    ...errorHandler,
  });
};
